/**
 * Page-key catalog for entitlements. Hand-mirrored with the backend's
 * app/core/entitlements/constants.py::PageKey - there's no shared-types
 * codegen in this stack, so keep the two in sync manually when a page key
 * is added or removed.
 */
export const PAGE_KEYS = {
  // Authenticated (non-admin) pages
  DASHBOARD: 'dashboard',
  DRAFTS: 'drafts',
  PROFILE: 'profile',
  SETTINGS: 'settings',
  CALCULATOR: 'calculator',
  TOASTMASTERS: 'toastmasters',
  BLOG_CREATE: 'blog_create',
  BLOG_EDIT: 'blog_edit',
  BLOG_PREVIEW: 'blog_preview',

  // Admin pages
  ADMIN_DASHBOARD: 'admin.dashboard',
  ADMIN_USERS: 'admin.users',
  ADMIN_BLOGS: 'admin.blogs',
  ADMIN_ANALYTICS: 'admin.analytics',
  ADMIN_PORTFOLIO: 'admin.portfolio',
  ADMIN_FLASHCARDS: 'admin.flashcards',
  ADMIN_ACTIVITY: 'admin.activity',
  ADMIN_ERRORS: 'admin.errors',
  // Never deny-able (enforced backend-side) - self-lockout has no recovery.
  ADMIN_ENTITLEMENTS: 'admin.entitlements',
} as const;

export type PageKeyValue = (typeof PAGE_KEYS)[keyof typeof PAGE_KEYS];

/** Pages gated by the public/user/admin access tier (see
 * entitlementsApiService.getPageLevels) - mirrors the backend's
 * CONFIGURABLE_PAGE_KEYS. Admin pages and the always-public content pages
 * (blog/about/projects/home, which have no PageKey at all) aren't part of
 * this system. */
export const CONFIGURABLE_PAGE_KEYS: string[] = [
  PAGE_KEYS.DASHBOARD,
  PAGE_KEYS.DRAFTS,
  PAGE_KEYS.PROFILE,
  PAGE_KEYS.SETTINGS,
  PAGE_KEYS.CALCULATOR,
  PAGE_KEYS.TOASTMASTERS,
  PAGE_KEYS.BLOG_CREATE,
  PAGE_KEYS.BLOG_EDIT,
  PAGE_KEYS.BLOG_PREVIEW,
];

export type AccessTier = 'public' | 'user' | 'admin';
export const DEFAULT_ACCESS_TIER: AccessTier = 'admin';
